import {
  useSuspenseQuery,
  UseSuspenseQueryOptions,
} from "@tanstack/react-query"
import type * as Api from "../../@client/api"
import { get } from "../get"
import { useHandleAsyncSafely } from "./use-handle-async-safely"

interface QueryOptionParam<ActionName extends keyof Api.GET>
  extends Partial<
    UseSuspenseQueryOptions<
      Api.Output[ActionName],
      Error,
      Api.Output[ActionName],
      (ActionName | Api.Input[ActionName] | string)[]
    >
  > {}

export function useSuspenseQueryGet<ActionName extends keyof Api.GET>(
  url: ActionName,
  input: Api.Input[ActionName],
  queryOptions?: QueryOptionParam<ActionName>,
  requestInit?: RequestInit
) {
  const handleAsyncSafely = useHandleAsyncSafely<Api.Output[ActionName]>()

  return useSuspenseQuery({
    retry: false,
    queryKey: [url, input],
    ...queryOptions,
    queryFn: () =>
      handleAsyncSafely(() =>
        get(url, input, requestInit ? requestInit : { headers: {} })
      ),
  })
}
